if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

/* ── Allsleepers size-grid quick add ───────────────────────────── */
if (!window.__sizeAddBound) {
  window.__sizeAddBound = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-size-add]');
    if (!btn || btn.disabled) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.classList.add('is-added');
        btn.textContent = '✓';
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              if (typeof drawer.renderContents === 'function') drawer.renderContents({ sections: sections });
              if (typeof drawer.open === 'function') drawer.open();
            })
            .catch(function () {});
        }
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = orig;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () { window.location.href = btn.closest('[data-product-url]') ? btn.closest('[data-product-url]').dataset.productUrl : '/cart'; });
  });
}

/* ── Mobile QUICK ADD bottom sheet ─────────────────────────────── */
if (!window.__qamBound) {
  window.__qamBound = true;
  var qamClose = function () {
    var s = document.getElementById('QuickAddSheet');
    if (s) s.hidden = true;
  };
  var qamAddToCart = function (variantId, after) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (after) after();
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              if (typeof drawer.renderContents === 'function') drawer.renderContents({ sections: sections });
              if (typeof drawer.open === 'function') drawer.open();
            })
            .catch(function () {});
        }
      })
      .catch(function () { window.location.href = '/cart'; });
  };
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-qam-open]');
    if (open) {
      e.preventDefault();
      var coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;
      // Desktop behavior for carousel "+": instant add (one size) or go to product page (sized)
      if (!coarse && open.classList.contains('piwb__quickadd')) {
        if (open.dataset.directId) { qamAddToCart(open.dataset.directId); }
        else if (open.dataset.url) { window.location.href = open.dataset.url; }
        return;
      }
      var s = document.getElementById('QuickAddSheet');
      if (!s) return;
      s.querySelector('.qam__title').textContent = open.dataset.title || '';
      s.querySelector('.qam__img').src = open.dataset.image || '';
      var imgLink = s.querySelector('[data-qam-url]');
      if (imgLink) {
        if (open.dataset.url) { imgLink.href = open.dataset.url; imgLink.style.pointerEvents = ''; }
        else { imgLink.removeAttribute('href'); imgLink.style.pointerEvents = 'none'; }
      }
      s.querySelector('.qam__now').textContent = open.dataset.price || '';
      var badge = s.querySelector('.qam__badge');
      if (badge) {
        if (open.dataset.badge) { badge.textContent = open.dataset.badge; badge.hidden = false; }
        else badge.hidden = true;
      }
      var sub = s.querySelector('.qam__subtitle');
      if (sub) {
        if (open.dataset.type) { sub.textContent = open.dataset.type; sub.hidden = false; }
        else sub.hidden = true;
      }
      var was = s.querySelector('.qam__was');
      if (open.dataset.compare) { was.textContent = open.dataset.compare; was.hidden = false; }
      else { was.hidden = true; }
      var wrap = s.querySelector('[data-qam-sizes]');
      wrap.innerHTML = '';
      var variants = [];
      try { variants = JSON.parse(open.dataset.variants || '[]'); } catch (err) {}
      variants.forEach(function (v) {
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'qam__row';
        if (!v.available) row.disabled = true;
        row.innerHTML = '<span class="qam__row-size"></span>' + (v.available
          ? '<span class="qam__row-add">Add to bag <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><path d="M12 8v8M8 12h8"/></svg></span>'
          : '<span>Out of stock</span>');
        row.querySelector('.qam__row-size').textContent = variants.length === 1 ? '1 SIZE' : v.title;
        row.addEventListener('click', function () {
          if (row.disabled) return;
          row.disabled = true;
          qamAddToCart(v.id, qamClose);
        });
        wrap.appendChild(row);
      });
      s.hidden = false;
      return;
    }
    if (e.target.closest('[data-qam-close]')) qamClose();
  });
}
